angular.module('tgaApp').factory('authInterceptor', [
  'authService',
  'envService',
  'domainService',
  function (authService, envService, domainService) {
    const serverAddress = envService.read('serverAddress');
    const authInjector = {
      request(config) {
        const auth = authService.getAuthentication();

        if (config.url.substring(0, serverAddress.length) === serverAddress) {
          if (auth && auth.isAuth) {
            config.headers['X-TGA-KEY'] = auth.token;
          }

          config.headers['X-DOMAIN'] = domainService.domain;
        }

        return config;
      },
    };
    return authInjector;
  },
]);

angular.module('tgaApp').config([
  '$httpProvider',
  function ($httpProvider) {
    $httpProvider.interceptors.push('authInterceptor');
  },
]);
